    export const CUSTOM_BREAKPOINTS = {
        XSMALL: '(max-width: 575px)',
        SMALL: '(min-width: 576px) and (max-width: 991px)',
        MEDIUM: '(min-width: 992px) and (max-width: 1279px)',
        LARGE: '(min-width: 1280px) and (max-width: 1599px)',
        XLARGE: '(min-width: 1600px)'
    };